import { takeEvery, takeLatest } from 'redux-saga/effects';
import { DASHBOARD_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_CONFIGURED_VIOLATIONS,
  LOAD_DAY_STAT,
  LOAD_EXPORT_STATUS,
  LOAD_LAST_SESSION,
  GET_CAMERA_STREAM,
  CREATE_SCREENSHOT,
  ALL_NODE_EVENT,
  LOAD_NODE_STATE,
} from '../actions';
import loadDayStat from './loadDayStat';
import loadLastSession from './loadLastSession';
import loadConfiguredViolations from './loadConfiguredViolations';
import loadExportStatus from './loadExportStatus';
import getCameraStream from './getCameraStream';
import createScreenshot from './createScreenshot';
import allNodeEvent from './allNodeEvent';
import loadNodeState from './loadNodeState';

export default function* watchDashboard() {
  yield takeEvery(DASHBOARD_MODULE + LOAD_DAY_STAT, loadDayStat);
  yield takeEvery(DASHBOARD_MODULE + LOAD_LAST_SESSION, loadLastSession);
  yield takeEvery(DASHBOARD_MODULE + LOAD_CONFIGURED_VIOLATIONS, loadConfiguredViolations);
  yield takeEvery(DASHBOARD_MODULE + LOAD_EXPORT_STATUS, loadExportStatus);
  yield takeEvery(DASHBOARD_MODULE + GET_CAMERA_STREAM, getCameraStream);
  yield takeEvery(DASHBOARD_MODULE + CREATE_SCREENSHOT, createScreenshot);
  yield takeLatest(DASHBOARD_MODULE + ALL_NODE_EVENT, allNodeEvent);
  yield takeLatest(DASHBOARD_MODULE + LOAD_NODE_STATE, loadNodeState);
}
